import { TopNavShellRoot } from './top-nav-shell-root';
import { TopNavShellHeader } from './top-nav-shell-header';
import { TopNavShellMain } from './top-nav-shell-main';
import { SegmentedNav, SegmentedNavItem } from './segmented-nav';
import { BottomNav, BottomNavItem } from './bottom-nav';
import { MobileNavBar } from './mobile-nav-bar';

export const TopNavShell = {
  Root: TopNavShellRoot,
  Header: TopNavShellHeader,
  Nav: SegmentedNav,
  NavItem: SegmentedNavItem,
  BottomNav,
  BottomNavItem,
  Main: TopNavShellMain,
  MobileNavBar,
};

export type { TopNavShellRootProps } from './top-nav-shell-root';
export type { TopNavShellHeaderProps } from './top-nav-shell-header';
export type { TopNavShellMainProps } from './top-nav-shell-main';
export {
  SegmentedNav,
  SegmentedNavItem,
  segmentedNavItemVariants,
  type SegmentedNavItemProps,
} from './segmented-nav';
export {
  BottomNav,
  BottomNavItem,
  bottomNavItemVariants,
  type BottomNavItemProps,
} from './bottom-nav';
export {
  MobileNavBar,
  MobileNavBarBack,
  type MobileNavBarProps,
  type MobileNavBarBackProps,
} from './mobile-nav-bar';
